export default __webpack_public_path__ + "static/media/prospect_newsfeed.fc4a4ca7.png";